import { ICloudbasePlatformInfo } from '@cloudbase/types';

export const Platform: ICloudbasePlatformInfo = {};
